import React from 'react';
import { FaDownload } from "react-icons/fa";
import Header from '../components/Header';

const Account = () => {
  return (
    <>
    <div className='bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300'>
       
        <div className="p-6">
    
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Account Statement</h1>
        <button className="flex items-center gap-2 border rounded px-4 py-2 text-sm font-medium hover:bg-gray-100">
          <FaDownload />
          Export
        </button>
      </div>

      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-4">
        <input
          type="date"
          defaultValue="2025-08-06"
          className="border rounded px-3 py-2 bg-transparent"
        />
        <input
          type="text"
          defaultValue="9873310346"
          className="border rounded px-3 py-2 w-80 bg-transparent"
        />
        <select className="border rounded px-3 py-2 bg-transparent">
          <option>All</option>
          <option>Spot</option>
          <option>Funding</option>
        </select>
        <select className="border rounded px-3 py-2 bg-transparent">
          <option>Estimated Value</option>
        </select>
        <select className="border rounded px-3 py-2 bg-transparent">
          <option>USDT</option>
        </select>

        <button className="bg-yellow-400 hover:bg-yellow-500 text-black px-4 py-2 rounded">
          Search
        </button>
        <button className="bg-gray-200 hover:bg-gray-300 text-black px-4 py-2 rounded">
          Reset
        </button>
      </div>

      <hr className="my-4" />

      {/* Overview */}
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-bold">Overview</h2>
          <span className="text-xs text-gray-500">
            Data refreshes at UTC+0 daily.
          </span>
        </div>

        <div className="grid grid-cols-5 gap-4 mt-4 text-sm border-b py-10">
          <div>
            <p className="text-gray-500">Date</p>
            <p className="font-medium">2025-08-06</p>
          </div>
          <div>
            <p className="text-gray-500">User ID</p>
            <p className="font-medium">1140265487</p>
          </div>
          <div>
            <p className="text-gray-500">Account Type</p>
            <p className="font-medium">Master Account</p>
          </div>
          <div>
            <p className="text-gray-500">Wallet</p>
            <p className="font-medium">All</p>
          </div>
          <div>
            <p className="text-gray-500">Rate</p>
            <p className="font-medium">1 BTC</p>
            <p className="text-gray-500 text-xs">≈ 114,992 USDT</p>
          </div>
        </div>

        {/* Total Value */}
        <div className="grid grid-cols-3 gap-4 mt-8 py-10">
          <div>
            <p className="font-bold text-lg mb-2">Total Value</p>
            <p className="font-medium">-- BTC</p>
            <p className="text-gray-500 text-xs">≈ -- USDT</p>
          </div>
          <div>
            <p className="font-bold text-lg mb-2">Spot</p>
            <p className="font-medium">-- BTC</p>
            <p className="text-gray-500 text-xs">≈ -- USDT</p>
          </div>
          <div>
            <p className="font-bold text-lg mb-2">Funding</p>
            <p className="font-medium">-- BTC</p>
            <p className="text-gray-500 text-xs">≈ -- USDT</p>
          </div>
        </div>
      </div>

      <hr className="my-4" />

      {/* Spot */}
      <div>
        <h2 className="text-2xl font-bold">Spot</h2>
        <div className="mt-4">
          <p className="text-gray-500">Total Balance</p>
          <p className="font-medium">-- BTC</p>
          <p className="text-gray-500 text-xs">≈ -- USDT</p>
        </div>

        {/* Table */}
        <div className="mt-6">
          <table className="w-full text-sm border-t">
            <thead>
              <tr className="text-left">
                <th className="p-2">Coin</th>
                <th className="p-2 text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr className='text-center'>
                <td className="p-20 text-gray-400">No Record Found</td>
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
       <div className='border-y-2 pt-4'>
        <h2 className="text-2xl font-bold">Funding</h2>
        <div className="mt-4">
          <p className="text-gray-500">Total Balance</p>
          <p className="font-medium">-- BTC</p>
          <p className="text-gray-500 text-xs">≈ -- USDT</p>
        </div>

        {/* Table */}
        <div className="mt-6">
          <table className="w-full text-sm border-t">
            <thead>
              <tr className="text-left">
                <th className="p-2">Coin</th>
                <th className="p-2 text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr className='text-center'>
                <td className="p-20 text-gray-400">No Record Found</td>
               
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
    </>
  )
}

export default Account